var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibraries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H60V60H0Z",
    transform: "translate(573 511)",
    fill: "#c7cdd1",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8390",
    "data-name": "Rectangle 8390",
    width: 34.016,
    height: 45.283,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6546",
    "data-name": "Mask Group 6546",
    transform: "translate(-573 -511)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35258",
    "data-name": "Group 35258",
    transform: "translate(585.992 518.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35257",
    "data-name": "Group 35257",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36018",
    "data-name": "Path 36018",
    d: "M29.01,38H3.293A3.285,3.285,0,0,1,0,34.7V3.293A3.285,3.285,0,0,1,3.293,0H29.01Z",
    transform: "translate(0 0)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36019",
    "data-name": "Path 36019",
    d: "M29.818,39.248H4.991A1.69,1.69,0,0,1,3.3,37.558v-.267A1.69,1.69,0,0,1,4.991,35.6H29.818Z",
    transform: "translate(-0.363 -3.921)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36020",
    "data-name": "Path 36020",
    d: "M33.6,42.686H7.793A3.285,3.285,0,0,1,4.5,39.394V7.893A3.285,3.285,0,0,1,7.793,4.6H33.6Z",
    transform: "translate(-0.496 -0.507)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36021",
    "data-name": "Path 36021",
    d: "M33.6,42.686H7.793A3.285,3.285,0,0,1,4.5,39.394V7.893A3.285,3.285,0,0,1,7.793,4.6H33.6Z",
    transform: "translate(-0.496 -0.507)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.051
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36022",
    "data-name": "Path 36022",
    d: "M10.2,22.459,15.005,18.9l1.068,1.513-2.759,2.047L16.073,24.6l-1.068,1.424Z",
    transform: "translate(-1.123 -2.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36023",
    "data-name": "Path 36023",
    d: "M25.2,24.6l2.759-2.136L25.2,20.413,26.268,18.9l4.805,3.559-4.805,3.559Z",
    transform: "translate(-2.775 -2.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8389",
    "data-name": "Rectangle 8389",
    width: 10.056,
    height: 1.869,
    transform: "translate(15.361 24.872) rotate(-60.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36024",
    "data-name": "Path 36024",
    d: "M33.35,42.248H9.591A1.69,1.69,0,0,1,7.9,40.558v-.267A1.69,1.69,0,0,1,9.591,38.6H33.35Z",
    transform: "translate(-0.87 -4.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36025",
    "data-name": "Path 36025",
    d: "M11.778,40.8c-.089,2.581-.089,5.161-.178,7.831,1.157-1.068,2.314-2.225,3.559-3.293,1.157,1.068,2.225,2.225,3.381,3.293,0-2.581-.089-5.161-.089-7.831Z",
    transform: "translate(-1.278 -4.494)",
    fill: "#5048bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36026",
    "data-name": "Path 36026",
    d: "M11.778,40.8c-.089,2.581-.089,5.161-.178,7.831,1.157-1.068,2.314-2.225,3.559-3.293,1.157,1.068,2.225,2.225,3.381,3.293,0-2.581-.089-5.161-.089-7.831Z",
    transform: "translate(-1.278 -4.494)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.093
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraries);
export default __webpack_public_path__ + "static/media/libraries.34e7e277ed2a3fc775cc7dd5f0b427a5.svg";
export { ForwardRef as ReactComponent };